// extracted by mini-css-extract-plugin
export const pinItem = "column-pin-stack-module--pinItem--4FQ6I";
export const pinItemVisible = "column-pin-stack-module--pinItemVisible--223xh";
export const pinCardBack = "column-pin-stack-module--pinCardBack--kenya";
export const pinCardFront = "column-pin-stack-module--pinCardFront--2EunS";